import {
  Component,
  ElementRef,
  Input,
  OnInit,
  ViewChild,
} from "@angular/core";
import { Platform } from "@ionic/angular";
import { Subject } from "rxjs";

import { ConfigService } from "src/app/services/config/config.service";
import { EventsService } from "src/app/services/event/event.service";
import { GamesService } from "src/app/services/lobby/games.service";
import { KeywordsService } from "src/app/services/lobby/keywords.service";
import { LobbyStateService } from "src/app/services/lobbyState/lobby-state.service";
import { MobileDataService } from "src/app/services/mobile-data/mobile-data.service";
import { Navigator } from "../../menu/navigator";
import { UserSessionService } from "src/app/services/user-session/user-session.service";
import { LastPlayed } from "./models/last-played-model";
import { LobbyNavigator } from "src/app/services/lobby/lobby-navigator.service";
import { LobbyService } from "src/app/services/lobby/lobby.service";

@Component({
  selector: "lobby-verticals",
  templateUrl: "./lobby-verticals.component.html",
  styleUrls: ["lobby-verticals.component.scss"],
})

export class LobbyVerticalsComponent implements OnInit {
  @Input() mobileLobby: string;
  @ViewChild("widgetsContent", { read: ElementRef })

  public widgetsContent: ElementRef<any>;

  public _recentGamesSubject: Subject<any>;
  public allCasinoGames = [];
  public allGamesDataArray = [];
  public authBasedKeywords: any;
  public buttonLeft;
  public buttonRight;
  public filteredCasinoGames: any;
  public filterKeyWordList = [];
  public searchKeyWordList = [];
  public gamesLastPlayed: any;
  public isAuthenticated: boolean;
  public isMobile: boolean;
  public isMobileApp: boolean;
  public LastPlayedGamesPresent: boolean;
  public lobbyName: string;
  public scrollWidth;
  public selectedItem: any;
  public showLeftButton: boolean = false;
  public showRightButton: boolean = false;
  public showSearchButton: boolean = true;
  public filterKeyWord: any;
  public isMobileWeb = false;
  public emittedObject: { action_type?: string, keyword?: string, gamesInfo: any, lastPlayed?: LastPlayed };
  private isFromReloadConfig: boolean = false;

  constructor(
    private readonly eventsService: EventsService,
    private readonly keywordsService: KeywordsService,
    private readonly lobbyNavigator: LobbyNavigator,
    private readonly lobbyStateService: LobbyStateService,
    private readonly userSessionService: UserSessionService,
    private config: ConfigService,
    private gamesService: GamesService,
    private mobileData: MobileDataService,
    private lobbyService: LobbyService,
    private navigator: Navigator,
    private platform: Platform,
  ) {
    this.isMobileWeb = this.platform.is('mobile')
  }

  public scrollRight(): void {

    // if (this.widgetsContent.nativeElement.scrollWidth - this.widgetsContent.nativeElement.offsetWidth - 150 <= this.widgetsContent.nativeElement.scrollLeft){
    //   this.showRightButton = false;
    // } else {
    //   this.showLeftButton = true;
    // }

    return this.widgetsContent.nativeElement.scrollTo({
      left: this.widgetsContent.nativeElement.scrollLeft + 150,
      behavior: "smooth",
    });
  }

  public scrollLeft(): void {
    // if (this.widgetsContent.nativeElement.scrollLeft <= 150) {
    //   this.showLeftButton = false;
    // } else {
    //   this.showRightButton = true;
    // }

    return this.widgetsContent.nativeElement.scrollTo({
      left: this.widgetsContent.nativeElement.scrollLeft - 150,
      behavior: "smooth",
    });
  }

  ngOnInit(): void {
    this.userSessionService.isAuthenticated().then((res) => {
      if (res) this.isAuthenticated = true;
    });

    this.isMobile = this.platform.is("capacitor") || this.platform.is('mobileweb');
    this.isMobileApp = this.platform.is("capacitor");

    this.loadLobbies();

    this.eventsService.subscribe("event:config:reload", () => {
      this.config.isLoaded().then(() => {
        setTimeout(() => {
          this.isAuthenticated = false;
          this.getLobby();
        }, 500);
      });
    });

    this.eventsService.subscribe("action:changeTab", (tabName) => {
      this.isAuthenticated = true;
      this.lobbyStateService.saveActiveKeyword(null, this.lobbyName);
      this.getLobby();

      let defaultKeywordData = this.getDefaultKeywordData();
      this.eventsService.publish("searchbar:keyword:click", defaultKeywordData);
    });

    this.eventsService.subscribe("events:searchbar:showButton", () => {
      this.showSearchButton = true;
    });

    this.lobbyStateService.getCurrentKeywordSubject().subscribe((data) => {
      this.selectedItem = data.keyword;
      this.lobbyNavigator.setSelectedItem(this.selectedItem);
    });

    this.eventsService.subscribe("searchbar:keyword:click", (data) => {
      if (data) {
        this.onSelectKeyword(data);
        if (!this.isMobileApp)
          setTimeout(() => {
            if (document.getElementsByClassName("keywords-isactive")[0]) {
              document.getElementsByClassName("keywords-isactive")[0].scrollIntoView({ behavior: 'smooth', inline: "center" });
            }
          }, 200)
      } else {
        this.selectedItem = null;
        this.lobbyNavigator.setSelectedItem(this.selectedItem);
      }
    });

    this.userSessionService.getUserStatus().subscribe((userStatus) => {
      if (userStatus == null) {
        this.isAuthenticated = false;
        this.updateKeywordListBasedOnAuth(userStatus);
      } else {
        this.isAuthenticated = true;
        this.loadCasinoLobby();
      }
    });

    this.eventsService.subscribe("event:keywords:deselectall", () => {
      this.selectedItem = null;
      this.lobbyNavigator.setSelectedItem(this.selectedItem);
    });

    // Use this event to auto scroll selected keyword in view horizontally.
    this.eventsService.subscribe("event:autoScrollselectedkeyword", () => {
      this.autoScrollSelectedItem();
    });

    this.eventsService.subscribe("action:reloadLobbies", () => {
      this.loadLobbies();
      this.isFromReloadConfig = true;
    });
  }

  loadLobbies(){
    this.config.isLoaded().then(() => {
      this.getLobby();
    });
  }

  private getLobby(): void {

    this.lobbyNavigator.getLobbyList().then((data: any[]) => {
      this.mobileData.setLobbiesList(data);
      const mainLobbies = data.filter((l) => l.placement === 'MAIN');
      const bottomLobbies = data.filter((l) => l.placement === 'BOTTOM');

      if (bottomLobbies && bottomLobbies.length > 0) {
        let bottomLobbyName = bottomLobbies[0].name;
        this.lobbyNavigator.loadCasinoBottomLobby(bottomLobbyName, this.isFromReloadConfig);
      }

      if (mainLobbies.length) {
        this.lobbyName = mainLobbies[0].name;
        this.keywordsService.setKeyword(this.lobbyName);
        this.gamesService.setLobbyName(this.lobbyName);
        this.loadCasinoLobby();

      }
      this.isFromReloadConfig = false;
    });
  }

  private loadCasinoLobby() {

    this.keywordsService.getKeywordsAndGames(this.lobbyName, this.isFromReloadConfig).then(
      (data) => {
        // full list of keywords, can get filtered below
        let keywordList = data[0]?.payload;

        //all Games list
        this.allCasinoGames = data[1]?.payload;
        this.lobbyNavigator.setAllCasinoGames(this.allCasinoGames);

        this.filterKeyWordList = keywordList;
        if(this.filterKeyWordList.length > 0){
          this.lobbyStateService.setFirstTopKeyword(this.filterKeyWordList[0]);
        }
        this.lobbyNavigator.setKeywordList(this.filterKeyWordList);

        if (!this.isAuthenticated) {
          this.updateKeywordListBasedOnAuth(this.isAuthenticated);
        }
        this.createMobileSearchKeywordList(this.filterKeyWordList);
        if (this.isMobileApp && this.mobileData.getBottomKeywordList()) {
          this.filterKeyWordList = this.mobileData.getBottomKeywordList();
          this.lobbyNavigator.setBottomKeywordList(this.filterKeyWordList);
        }

        this.keywordsService.setLiveDealerKeywordInfo(this.filterKeyWordList);
        this.allGamesDataList();

        let defaultKeywordData = this.getDefaultKeywordData();
        this.selectedItem = defaultKeywordData?.name;
        this.lobbyNavigator.setSelectedItem(this.selectedItem);

        if (~this.selectedItem?.indexOf("Recently Played")) {
          if (this.userSessionService.isAuthenticated()) {
            this.lobbyNavigator.onGetLastPlayedGames(this.lobbyName);
          } else {
            defaultKeywordData = this.filterKeyWordList[0];
            this.selectedItem = this.filterKeyWordList[0]?.name;
            this.lobbyNavigator.setSelectedItem(this.selectedItem);
            this.LastPlayedGamesPresent = false;
            this.lobbyStateService.saveActiveKeyword(defaultKeywordData, this.lobbyName);
          }
        }
        this.emitKeywordandGames();
      },
      (error) => console.error(error)
    );
  }

  private updateKeywordListBasedOnAuth(authStatus): any {
    this.authBasedKeywords = this.config.getConfig()["FEATURE_AUTH_KEYWORDS"] ?? ["FAVOURITEGAMESCASINODESKTOPWEBNJMAIN", "FAVOURITEGAMESCASINOMOBILEWEBNJMAIN"];

    if (!authStatus) {
      this.filterKeyWordList = this.filterKeyWordList.filter((f) => !this.authBasedKeywords.includes(f.keyword_code));

    }
    return;
  }

  private allGamesDataList() {
    //games for search bar
    //rebuild array to make it searchbale by angular pipe
    if (!!this.allCasinoGames) {
      let casinoGames = this.allCasinoGames;

      let allCasinoGames: any = Object.keys(this.allCasinoGames).map(function (key) {
        return casinoGames[key.toString()];
      });

      this.allGamesDataArray = allCasinoGames.reduce(function (a, b) {
        return a.concat(b);
      }, []);
    }
  }

  private getDefaultKeywordData(): any {
    return this.lobbyStateService.currentActiveKeyword(this.lobbyName) ?? this.filterKeyWordList[0];
  }

  //set of function for last played

  private onSelectKeyword(data) {
    this.lobbyService.setCurrentActiveKeywordItem(data);
    return this.lobbyNavigator.selectKeyword(data);
  }

  private emitKeywordandGames(data?: any, lastPlayed: boolean = false) {
    this.lobbyNavigator.emitKeywordandGames(data, lastPlayed);
    return;
  }

  public createMobileSearchKeywordList(keywordList) {
    if (keywordList?.length == 0) return;
    this.searchKeyWordList = keywordList.filter((k) => {
      return k.action_type === "gamelist";
    });
  }


  public showSearchComponent() {
    this.showSearchButton = false;
    this.navigator.openPopover(
      "SearchbarComponent",
      {
        keyWordsListData: this.filterKeyWordList,
        gamesListData: this.allGamesDataArray,
      },
      "searchbar-component",
      true,
      true,
      true
    );
    return;
  }

  autoScrollSelectedItem() {
    this.widgetsContent?.nativeElement?.getElementsByClassName('keywords-isactive')[0]?.scrollIntoView();
  }
}
